module.exports = __webpack_public_path__ + "img/logo.d5e5ffb6.svg";